import { Col, Form, Input, Rate, Row, Select } from "antd";
import "../css/devboost.css";
import { CustomTagRender } from "../partials/custom-tag-render.partial";

const { TextArea } = Input;

export const Feedback = () => (
    <>
        <Row>
            <Col xs={24} sm={24} md={12}>
                <Form.Item
                    name="score"
                    label="Calificación General de Satisfacción"
                    rules={[{ required: true, message: "Requerido" }]}
                >
                    <Rate
                        name="score"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
                <Form.Item
                    name="benefits"
                    label="Principales Beneficios Obtenidos"
                    rules={[{ required: true, message: "Requerido" }]}
                >
                    <Select
                        mode="tags"
                        style={{ width: "100%" }}
                        placeholder="Ej: Mayor velocidad, Menos errores, Mejora de calidad"
                        options={[]}
                        tagRender={CustomTagRender}
                        onInputKeyDown={e => {
                            const value = e.target.value;
                            // Si ya hay 20 caracteres, bloquea cualquier tecla excepto Backspace y flechas
                            if (value && value.length >= 20 && !["Backspace", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        // Este evento corta el texto si el usuario pega algo largo
                        onInput={e => {
                            if (e.target.value.length > 20) {
                                e.target.value = e.target.value.slice(0, 20);
                            }
                        }}
                    />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    name="challenge"
                    label="Desafíos o Limitaciones Encontradas"
                    rules={[{ required: false, message: "Requerido" }]}
                    style={{ margin: "0 0 8px 0" }}
                >
                    <TextArea name="challenge" autoSize />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    name="comment"
                    label="Comentarios Adicionales"
                    rules={[{ required: true, message: "Requerido" }]}
                    style={{ margin: "0 0 8px 0" }}
                >
                    <TextArea name="comment" autoSize />
                </Form.Item>
            </Col>
        </Row>
    </>
)